module.exports = __webpack_public_path__ + "img/icon_content_t_9.0.1.0_202310101542.png";